import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import Ariane from "../components/Ariane/ariane"
import root from "window-or-global"
import { navigate } from "gatsby"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  reservationContainer,
  reservationActions,
  reservationActionsWithBack,
  reservationActionsArrowLeft,
  reservationActionsArrowRight,
  changeTypeInFormClass,
} from "../components/Reservation/reservation.module.scss"
import { ReservationActions } from "../styled-components/reservation-global-styled"
import { ReservationPart1 } from "../components/Reservation/Part1/reservation-part-1"
import { ReservationPart2 } from "../components/Reservation/Part2/reservation-part-2"
import { ReservationPart4 } from "../components/Reservation/Part4/reservation-part-4"
import { ReservationPart5 } from "../components/Reservation/Part5/reservation-part-5"
import { ReservationPart6 } from "../components/Reservation/Part6/reservation-part-6"
import { ReservationPart7 } from "../components/Reservation/Part7/reservation-part-7"
import arrow from "gatsby-theme-blank/src/images/full-arrow-white.svg"
import arrowBlack from "gatsby-theme-blank/src/images/full-arrow-black.svg"
import { MaintenancePage } from "../components/MaintenancePage/maintenance-page"

const ReservationForm = ({ arianeDisplayed }) => {
  const [isMaintenance, setIsMaintenance] = useState(false)
  const [step, setStep] = useState(0)
  const [loadingLock, setLoadingLock] = useState(false)
  const [uuidReservation, setUuidReservation] = useState("")
  const [typesReservationData, setTypesReservationData] = useState({})
  const [sortedTypesReservationData, setSortedTypesReservationData] = useState(
    []
  )
  const [typeChoisi, setTypeChoisi] = useState(0)
  const [nombrePersonne, setNombrePersonne] = useState(1)
  const [weekOffset, setWeekOffset] = useState(0)
  const [creneauxDisponibles, setCreneauxDisponibles] = useState({})
  const [creneauChoisi, setCreneauChoisi] = useState([])
  const [creneauxGroupes, setCreneauxGroupes] = useState([])
  const [contactInfo, setContactInfo] = useState({
    nom: "",
    prenom: "",
    phone: "",
    mail: "",
    comm: "",
    cases: [],
    textes: [],
  })
  const allowed = useBuildData().site_settings.display_reservation
  const stepRefs = useRef({
    2: useRef(null),
    3: useRef(null),
    4: useRef(null),
    5: useRef(null),
  })
  useEffect(() => {
    if (stepRefs.current[step] && stepRefs.current[step].current) {
      stepRefs.current[step].current.focus()
    }
  }, [step, stepRefs])
  useEffect(() => {
    if (!allowed) {
      navigate("/")
    }
    const urlTypes =
      process.env.GATSBYSIDE_DRUPAL_URL + "/api/reservation/types"
    fetch(urlTypes)
      .then((response) => {
        return response.json()
      })
      .then((resultDataTypes) => {
        setTypesReservationData(resultDataTypes)

        // On créé un tableu trié par libellé pour l'affichage
        const typeReservationArray = []
        for (const prop in resultDataTypes) {
          // On fix le lien pour les images
          resultDataTypes[prop].texte_commentaire[0].processed =
            resultDataTypes[prop].texte_commentaire[0].processed.replace(
              'src="/sites',
              'src="' + process.env.GATSBYSIDE_DRUPAL_URL + "/sites"
            )

          typeReservationArray.push({
            id: resultDataTypes[prop].id[0].value,
            libelle: resultDataTypes[prop].libelle[0].value,
          })
        }
        typeReservationArray.sort((type1, type2) => {
          return type1.libelle.localeCompare(type2.libelle)
        })
        setSortedTypesReservationData(typeReservationArray)
        if (typeReservationArray.length === 1) {
          setTypeChoisi(typeReservationArray[0].id)
        }
        const url = root.location.search
        // On décode les éventuelles url provenant de mails
        // n'ayant pas activé le format html
        const params = url.replace("&amp;", "&").split("id=")
        const paramsForType = url.replace("&amp;", "&").split("type=")
        if (paramsForType.length && paramsForType[1]) {
          setTypeChoisi(paramsForType[1])
        }
        if (params.length && params[1] && paramsForType.length >= 1) {
          const paramsWithoutDelete = params[1].split("&delete")
          if (paramsWithoutDelete.length > 1) {
            if (
              root.confirm("Voulez-vous vraiment annuler votre réservation ?")
            ) {
              const urlDeletion =
                process.env.GATSBYSIDE_DRUPAL_URL +
                "/api/reservation/delete?id=" +
                paramsWithoutDelete[0]
              fetch(urlDeletion)
                .then((response) => {
                  if (response.status === 200) {
                    setStep(5)
                    return
                  }
                  setUuidReservation("")
                  throw new Error()
                })
                .catch((error) => {
                  alert("Cette réservation n'existe pas ou a expiré.")
                })
            }
          }
        }
      })
  }, [])

  useEffect(() => {
    const fetchMaintenance = async () => {
      const resp = await fetch(
        process.env.GATSBYSIDE_DRUPAL_URL + `/api/get/maintenance/state`
      )
      const maintenanceMessage = await resp.text()
      setIsMaintenance(maintenanceMessage !== "0")
    }

    fetchMaintenance()
  }, [])

  const changeTypeInForm = (event) => {
    const type = event.target.value
    if (type === "null") {
      return
    }
    setStep(1)
    changeType(type)
    setCreneauChoisi([])
  }
  const getCreneaux = function (offset) {
    setWeekOffset(offset)

    fetch(process.env.GATSBYSIDE_DRUPAL_URL + "/api/reservation/creneaux", {
      method: "POST",
      body: JSON.stringify({
        typeChoisi: typeChoisi,
        nombrePersonne: nombrePersonne,
        weekOffset: offset,
        uuidReservation: uuidReservation,
        firstRender: true,
      }),
    })
      .then((res) => {
        return res.json()
      })
      .then((res) => {
        if (!res.hasReservation)
          alert("Aucun créneau libre trouvé dans les 6 prochains mois")
        setCreneauxDisponibles(res.semaine)
        setWeekOffset(res.offset)
        setStep(3)
        setLoadingLock(false)
      })
      .catch((error) => {
        getCreneaux(parseInt(offset) + 1)
      })
  }

  const changeStep = function (direction) {
    root.scrollTo(0, 0)
    const newStep = step + direction
    switch (newStep) {
      // L'user revient dans le choix des types
      case 0:
        setStep(0)
        break

      // L'user a choisi un type et cliqué sur suivant
      // On affiche la description du type
      case 1: {
        setStep(1)
        break
      }
      // L'user a lu la description et cliqué sur suivant
      // On affiche le formulaire du choix du nombre de personnes
      case 2:
        setStep(2)
        break

      // L'user a rentré ses informations et cliqué sur suivant
      // On fetch et affiche les créneaux disponibles
      case 3: {
        const validation = formValidation()
        if (validation !== true) {
          alert(validation)
          break
        }
        setLoadingLock(true)
        getCreneaux(weekOffset)
        setStep(3)
        break
      }
      // L'user a choisi un créneau et cliqué sur suivant
      // On affiche le récapitulatif
      case 4:
        if (loadingLock) break
        if (creneauChoisi.length === 0) {
          alert("Veuillez choisir une date de réservation.")
          break
        }
        setStep(4)
        break
      // L'user a submit le form
      case 5:
        setStep(5)
        break

      default:
        setStep(0)
        break
    }
  }

  const formValidation = function () {
    let error = ""
    if (!contactInfo.nom) error += "Veuillez renseigner votre nom\n"
    if (!contactInfo.prenom) error += "Veuillez renseigner votre prénom\n"
    if (!contactInfo.phone)
      error += "Veuillez renseigner un numéro de téléphone\n"
    else if (contactInfo.phone.length < 10)
      error += "Veuillez renseigner un numéro de téléphone valide\n"
    if (!contactInfo.mail) error += "Veuillez renseigner une adresse mail\n"
    if (contactInfo.mail) {
      const mailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!mailValidation.test(contactInfo.mail)) {
        error += "L'adresse mail renseignée n'est pas valide\n"
      }
    }
    return !error ? true : error
  }

  const changeType = function (type) {
    setTypeChoisi(type)
    setNombrePersonne(1)
    // On initialise l'état des checkbox en fonction du type choisi
    const cases = []
    typesReservationData[type].cases_cochables.map(
      (caseCochable, index) => (cases[index] = false)
    )
    const textes = []
    typesReservationData[type].textes_supplementaires.map(
      (texteSupplementaire, index) => (textes[index] = "")
    )
    setContactInfo({ ...contactInfo, cases: cases, textes: textes })
  }

  const changeWeekOffset = function (direction, set = false) {
    if (loadingLock) return
    setLoadingLock(true)
    let newWeekOffset
    if (set) {
      newWeekOffset = direction
    } else {
      newWeekOffset = parseInt(weekOffset) + parseInt(direction)
    }
    setWeekOffset(newWeekOffset)
    fetch(process.env.GATSBYSIDE_DRUPAL_URL + "/api/reservation/creneaux", {
      method: "POST",
      body: JSON.stringify({
        typeChoisi: typeChoisi,
        nombrePersonne: nombrePersonne,
        weekOffset: newWeekOffset,
      }),
    })
      .then((res) => {
        return res.json()
      })
      .then((res) => {
        setCreneauxDisponibles(res.semaine)
        setLoadingLock(false)
      })
  }

  const groupCreneaux = (creneaux) => {
    if (!creneaux.length) return []

    creneaux.sort()

    const actual = { start: null, end: null, date: null }
    const final = []

    // On vérifie le début et la fin de chaque créneau pour savoir s'ils se suivent
    creneaux.map((creneau, index) => {
      const split = creneau.split(" ")
      const date = split[0]
      const heureDebut = split[1]
      const heureFin = split[3]

      if (actual.start === null) {
        actual.start = heureDebut
        actual.end = heureFin
        actual.date = date
        return
      }

      if (heureDebut === actual.end && date === actual.date) {
        actual.end = heureFin
      } else {
        final.push({ ...actual })

        actual.start = heureDebut
        actual.end = heureFin
        actual.date = date
      }
    })

    if (actual.start !== null) {
      final.push(actual)
    }

    return final
  }

  const changeCreneau = function (creneau) {
    let newCreneauChoisi
    if (creneauChoisi.includes(creneau)) {
      newCreneauChoisi = creneauChoisi.filter((index) => index !== creneau)
    } else {
      newCreneauChoisi = [...creneauChoisi, creneau]
    }
    setCreneauChoisi(newCreneauChoisi)
    setCreneauxGroupes(groupCreneaux(newCreneauChoisi))
  }

  const submitForm = function () {
    let commCaseCochable = ""
    let commTexteSupplementaire = ""
    if (contactInfo.cases?.length) {
      contactInfo.cases.map((isChecked, index) => {
        // On concatène les cases cochables dans le commentaire
        if (isChecked)
          commCaseCochable +=
            " | " +
            typesReservationData[typeChoisi].cases_cochables[index].value +
            " : Oui"
      })
    }
    if (contactInfo.textes?.length) {
      contactInfo.textes.map((value, index) => {
        // On concatène les valeurs des textes dans le commentaire
        if (value)
          commTexteSupplementaire +=
            " <br/> " +
            typesReservationData[typeChoisi].textes_supplementaires[index]
              .value +
            " : " +
            value
      })
    }

    const commFinal =
      contactInfo.comm + commCaseCochable + commTexteSupplementaire
    fetch(process.env.GATSBYSIDE_DRUPAL_URL + "/api/reservation/submit", {
      method: "POST",
      body: JSON.stringify({
        typeChoisi: typeChoisi,
        nombrePersonne: nombrePersonne,
        creneauChoisi: creneauChoisi,
        creneauxGroupes: creneauxGroupes,
        nom: contactInfo.nom,
        prenom: contactInfo.prenom,
        phone: contactInfo.phone,
        mail: contactInfo.mail,
        comm: commFinal,
        uuidReservation: uuidReservation,
        origin: root.location.origin + root.location.pathname,
      }),
    })
      .then((res) => {
        return res
      })
      .then((res) => {
        if (res.status === 201) {
          changeStep(1)
        } else {
          alert("Une erreur est survenue lors de la soumission du formulaire.")
        }
      })
  }
  return (
    <Layout message="Demande de réservation">
      <SEO title="Demande de réservation" />
      {arianeDisplayed && (
        <Ariane pageName="Demande de réservation" isListing={true} />
      )}
      {!isMaintenance && (
        <>
          <div className={reservationContainer}>
            <ReservationActions
              className={
                step === 0 ? reservationActions : reservationActionsWithBack
              }
            >
              {step > 0 && step < 5 && !loadingLock && (
                <button className="btn" onClick={() => changeStep(-1)}>
                  <img
                    className={reservationActionsArrowLeft}
                    src={arianeDisplayed ? arrowBlack : arrow}
                    width={20}
                    height={20}
                  />{" "}
                  Précédent
                </button>
              )}
              {step > 0 && step < 5 && (
                <div className={changeTypeInFormClass}>
                  <p>Changer de ressource</p>
                  <select onChange={changeTypeInForm} value={typeChoisi}>
                    <option value="null">Sélectionner une ressource</option>
                    {sortedTypesReservationData.map((type, index) => (
                      <>
                        <option value={type.id}>{type.libelle}</option>
                      </>
                    ))}
                  </select>
                </div>
              )}
              {step < 4 && typeChoisi > 0 && !loadingLock && (
                <button className="btn" onClick={() => changeStep(1)}>
                  Suivant{" "}
                  <img
                    className={reservationActionsArrowRight}
                    src={arianeDisplayed ? arrowBlack : arrow}
                    width={20}
                    height={20}
                  />
                </button>
              )}
              {step === 4 && (
                <button
                  id={"validateAppointment"}
                  className="btn"
                  onClick={() => submitForm()}
                >
                  Valider la demande de réservation
                </button>
              )}
            </ReservationActions>
            {step === 0 && (
              <ReservationPart1
                sortedTypesReservationData={sortedTypesReservationData}
                changeType={changeType}
                typeChoisi={typeChoisi}
              />
            )}
            {step === 1 && (
              <ReservationPart2
                typesReservationData={typesReservationData}
                typeChoisi={typeChoisi}
              />
            )}
            {step === 2 && (
              <ReservationPart4
                contactInfo={contactInfo}
                setContactInfo={setContactInfo}
                commentairePossible={
                  typesReservationData[typeChoisi].commentaire_possible[0].value
                }
                casesCochables={
                  typesReservationData[typeChoisi].cases_cochables
                }
                textesSupplementaires={
                  typesReservationData[typeChoisi].textes_supplementaires
                }
                step={step}
                stepRefs={stepRefs}
              />
            )}
            {step === 3 && (
              <ReservationPart5
                creneauxDisponibles={creneauxDisponibles}
                changeWeekOffset={changeWeekOffset}
                changeCreneau={changeCreneau}
                creneauChoisi={creneauChoisi}
                loadingLock={loadingLock}
                step={step}
                stepRefs={stepRefs}
              />
            )}
            {step === 4 && (
              <ReservationPart6
                step={step}
                typesReservationData={typesReservationData}
                typeChoisi={typeChoisi}
                creneauxGroupes={creneauxGroupes}
                contactInfo={contactInfo}
                stepRefs={stepRefs}
              />
            )}
            {step === 5 && <ReservationPart7 mail={contactInfo.mail} />}
          </div>
        </>
      )}
      {isMaintenance && <MaintenancePage />}
    </Layout>
  )
}

ReservationForm.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default ReservationForm
